module.exports = {
  fetch: `query getEffectChains {
    effectChains(sortBy: "name.en", filter:{ type:{neq: "CUSTOM_EFFECT_CHAIN"}}) {
      id
      name {
        en
      }
      nodes
      type
      updatedAt
    }
  }`,
  fetchById: `
    query getEffectChain($id: ID) {
      effectChains(id: $id) {
        id
        name {
          en
        }
        nodes
        type
        updatedAt
      }
    }
  `,
  save: `mutation addEffectChain($value: EffectChainInput) {
    upsertEffectChain(effectChain: $value) {
      id
    }
  }`,
};
